import React, { Component } from 'react';
import CustomModal from "../../components/Modal/CustomModal";
import { Popover, OverlayTrigger } from "react-bootstrap";

import { Delete } from '../../funciones/RetiroFunction';

class RetiroMateriasTable extends Component {
    state = {
        openW: false,
        boton: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        }
    }

    showModal = () => {
        let {boton} = this.state;

        let contenidoModal = () => (
            <React.Fragment>
                <div>Deseas retirar <strong>{this.props.materia}</strong></div>
                <div>Esta opción no puede deshacerse y no podrás volver a inscribirla</div>
            </React.Fragment>
        )
        return (
            <CustomModal
                isopen =  {this.state.openW}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal()}
                boton1 = {<React.Fragment><i className={boton.icon}></i> {boton.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                funcion1 = {() => {
                    if (boton.disabled === true) return null;
                    
                    this.setState({
                        boton: {
                            icon: "fa fa-spinner fa-spin",
                            text: "Espera",
                            disabled: true
                        }
                    }, () => {
                        Delete(this.props.id, this.props.cantidad, (resp) => {
                            this.setState({
                                openW: resp[0]
                            }, () => {
                                if(resp[1]=== true) this.props.updLista()
                            })
                        })
                    })
                }}/>
        );
    }

    abrirModal = () => (e) => {
        this.setState({
            openW: true
        })
    }

    render() {
        const styles = {
            padding: 5, fontSize: 12
        }
        let { materia, seccion, tipo, uc, status } = this.props;

        let contenido = (
            <Popover bsSize="large" id="Inscrito">
                <div className="custom-alert-danger" align="center">Importante</div>
                <div align="justify" className="custom-mt-10">
                    Ya realizaste el proceso de retiro para esta materia, debes esperar que sea verificado por control de estudio
                </div>
            </Popover>
        )

        let contenido2 = (
            <Popover bsSize="large" id="Inscrito">
                <div className="custom-alert-danger" align="center">Importante</div>
                <div align="justify" className="custom-mt-10">
                    Ya realizaste el proceso de retiro para esta materia, ya fué aprobado por control de estudios, debes esperar que sea aprobado por administración
                </div>
            </Popover>
        )

        let botones = () => {
            switch (status){
                case "6": return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={contenido}>
                        <button style={{borderWidth: 1}} className="btn btn-xs btn-warning" title="Esta materia esta en evauación para su retiro"><i className="fa fa-clock-o"></i></button>
                    </OverlayTrigger>
                )
                case "7": return (
                    <OverlayTrigger trigger="focus" placement="right" overlay={contenido2}>
                        <button style={{borderWidth: 1}} className="btn btn-xs btn-warning" title="Esta materia esta en evauación para su retiro"><i className="fa fa-clock-o"></i></button>
                    </OverlayTrigger>
                )
                default: return(
                    <button onClick={this.abrirModal()} style={{borderWidth: 1}} className="btn btn-xs btn-danger" title="Retirar esta materia"><i className="fa fa-trash-o"></i></button>
                )
                
            }
        }

        return (
            <React.Fragment>
                <tr>
                    <td style={styles}>{materia}</td>
                    <td align="center" style={styles}>{seccion}</td>
                    <td align="center" style={styles}>{tipo}</td>
                    <td align="center" style={styles}>{uc}</td>
                    <td align="center" style={styles}>
                        {botones()}
                    </td>
                </tr>
                {this.showModal()}
            </React.Fragment>
        );
    }
}
 
export default RetiroMateriasTable;


// WEBPACK FOOTER //
// ./src/views/EstAcademicos/RetiroMateriasTable.jsx